import { Helmet } from 'react-helmet-async';
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import { Link } from 'react-router-dom';
import { IoCheckmarkCircleOutline } from "react-icons/io5";

const ConsultancyProgram = () => {
    return (
        <section>
            <div className='about-mijsc-section w-full bg-cover h-fit pb-5'>
                <Helmet>
                    <title>LMP Consultancy Program </title>
                    <meta name="description" content="Learn more about MIJSC, our mission, vision, and commitment to excellence." />
                </Helmet>
                <section className='bg-gray-200 w-full py-2 h-[70px]'>
                    <div className='text-sm flex items-center gap-2 py-3 place-content-center'>
                        <Link to="/" className="hover:text-green-600 font-semibold">Home</Link>
                        <MdKeyboardDoubleArrowRight className='text-green-600' />
                             <Link to="/" className="hover:text-green-600 font-semibold">MIJSC Programs</Link>
                         <MdKeyboardDoubleArrowRight className='text-green-600' />
                         <Link to="/" className="hover:text-green-600 font-semibold">LMP Consultancy Program</Link>
                    </div>
                </section>

                <div class="text-white space-y-3 py-5 rounded-md">
                    <div className="rounded-xl md:mx-8 mx-2 w-[95%] h-96 bg-cover bg-center transition-all duration-700"
                        style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/imgs/consultancy-program.avif)` }}> </div>
                </div>

                <div className='w-full text-justify md:flex md:mx-10 md:px-0 px-3'>

                    <section className='md:w-[94%] h-fit  mb-5 ' >
                        <h2 className='md:text-2xl text-lg py-3 text-green-600 font-semibold pt-10'>Phase - 3</h2>
                        <div className='flex gap-2 items-center'>
                            <IoCheckmarkCircleOutline className='text-green-600 text-xl' />
                            <p className='text-gray-500'>Facilitator: MIJSC @ IIMB </p>
                        </div>

                        <div className='flex gap-2 items-center'>
                            <IoCheckmarkCircleOutline className='text-green-600 text-xl' />
                            <p className='text-gray-500'>Delivered by: Industry Experts </p>
                        </div>

                        <div className='flex gap-2 items-center'>
                            <IoCheckmarkCircleOutline className='text-green-600 text-xl' />
                            <p className='text-gray-500'> Timeline: 6 Months </p>
                        </div>

                        <div className='flex gap-2 items-center'>
                            <IoCheckmarkCircleOutline className='text-green-600 text-xl' />
                            <p className='text-gray-500'> Mode of Delivery: Expert inputs (Online) + Industry Consultancy Projects (Offline) </p>
                        </div>

                        <div className='flex gap-2 items-center'>
                            <IoCheckmarkCircleOutline className='text-green-600 text-xl' />
                            <p className='text-gray-500'> Outcome: Engineering College Faculty as Industry Consultants </p>
                        </div>


                    </section>

                </div>
                <div className='mx-10'>
                    <div className='w-full my-5 text-justify md:flex bg-white shadow-md rounded-lg p-5 border-2 border-gray-200'>
                        <section className='md:w-[50%] h-fit  mr-5 mb-5 ' >
                            <img src="assets/imgs/phase-3.jpg" />
                        </section>
                        <section className='md:w-[50%] h-full md:ml-5 mb-5 place-self-center' >
                            <p className='text-gray-600 py-1 text-sm sm:text-base'>
                                The Consultancy program for Engineering College Faculty aims to create a team of Lean Consultants who will provide support to help address industry challenges, especially at SMEs.
                            </p>
                            <p className='text-gray-600 py-1 text-sm sm:text-base'>
                                The Consultancy program for Engineering College Faculty aims to create a team of Lean Consultants who will provide support to help address industry challenges, especially at SMEs.
                            </p>
                        </section>
                    </div>
                </div>



                <div className="w-[94%] text-justify md:mx-10 mx-2 md:mt-10">

                    <div className="w-full overflow-x-auto">
                        <table className="min-w-[900px] w-full border border-gray-300 text-sm">
                            <tbody>
                                {/* Header row 1 */}
                                <tr className="bg-gray-100">
                                    <th
                                        rowSpan={2}
                                        className="border border-gray-300 px-4 py-3 text-center font-semibold"
                                    >
                                        Course
                                    </th>
                                    <th
                                        rowSpan={2}
                                        className="border border-gray-300 px-4 py-3 text-center font-semibold"
                                    >
                                        Content
                                    </th>
                                    <th
                                        colSpan={9}
                                        className="border border-gray-300 px-4 py-3 text-center font-semibold"
                                    >
                                        Months
                                    </th>
                                </tr>

                                {/* Header row 2 */}
                                <tr className="bg-gray-100">
                                    {[1, 2, 3, 4, 5, 6, 7, 8, 9].map(month => (
                                        <th
                                            key={month}
                                            className="border border-gray-300 px-3 py-2 text-center"
                                        >
                                            {month}
                                        </th>
                                    ))}
                                </tr>

                                {/* Row 1 */}
                                <tr>
                                    <td
                                        rowSpan={2}
                                        className="border border-gray-300 px-4 py-3 align-top"
                                    >
                                        Consult to Compete
                                    </td>
                                    <td
                                        rowSpan={2}
                                        className="border border-gray-300 px-4 py-3 align-top"
                                    >
                                        6 Modules of Online Sessions by Industry Experts + Industry
                                        Application Projects
                                    </td>

                                    {[1, 2, 3, 4].map(i => (
                                        <td key={i} className="border border-gray-300 bg-gray-200"></td>
                                    ))}
                                    {[5, 6, 7, 8, 9].map(i => (
                                        <td key={i} className="border border-gray-300"></td>
                                    ))}
                                </tr>

                                {/* Row 2 */}
                                <tr>
                                    {[1, 2, 3, 4].map(i => (
                                        <td key={i} className="border border-gray-300"></td>
                                    ))}
                                    {[5, 6, 7, 8, 9].map(i => (
                                        <td key={i} className="border border-gray-300 bg-gray-200"></td>
                                    ))}
                                </tr>
                            </tbody>
                        </table>
                    </div>


                    <p className='text-green-600 font-bold my-4'>The course content of Consultancy Program for Engineering College faculty during Phase 3 is as shown above.</p>


                </div>
            </div>
        </section>
    )
}

export default ConsultancyProgram
